import produce from "immer";
import { Map } from "typings";
import { TagActions } from "./action";


export interface State 
{
    byId: Map<{}>;
}

const initialState: State = {
    byId: {}
};


const reducer = (state = initialState, action: TagActions): State => produce(state, draft =>
{
    if (action.type === "LOAD_TAGS_SUCCESS")
    {
        const { tags } = action;
        tags.forEach((tag: string) => draft.byId[tag] = {});
    }

    if (action.type === "REMOVE_TAG" )
    {
        const { tag } = action;
        const {[tag]:dummy, ...rest } = draft.byId;
        draft.byId = rest;
       
    }
   
});

export const getTags = (state: State): string[] => Object.keys(state.byId);

export default reducer;


// WEBPACK FOOTER //
// ./src/state/tag/index.ts